import { render, staticRenderFns } from "./index_question.vue?vue&type=template&id=2cab85db&scoped=true"
import script from "./index_question.vue?vue&type=script&lang=js"
export * from "./index_question.vue?vue&type=script&lang=js"
import style0 from "./index_question.vue?vue&type=style&index=0&id=2cab85db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cab85db",
  null
  
)

/* custom blocks */
import block0 from "./index_question.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports